import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';

const FailurePopUp = (props) => {
  return (
    <Container fluid>
      <Image src={require('./error.svg')} />
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center '>
          <span className='popup-title-bold'>לקוח יקר, לא ניתן להתקדם בתהליך</span>
        </Row>
        <Row className='justify-content-center '>
          {props.isNewImaiValidationFail ? (
            <span className='popup-title'> מספר הIMEI שהוקלד אינו תקין. אנא נסה שוב </span>
          ) : (
            <span className='popup-title'> נא פנה לאחראי\ת שירות להמשך טיפול. </span>
          )}
        </Row>
      </div>
      {props.isNewImaiValidationFail && (
        <Row className='justify-content-center mt-4'>
          <BtnSubmit
            isBusiness
            text={`נסה שוב`}
            onclick={() => {
              props.setIsShowPopup(false);
            }}
          />
        </Row>
      )}
      <Row className={!props.isNewImaiValidationFail ? 'justify-content-center mt-4' : 'justify-content-center mt-2'}>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            props.setIsShowPopup(false);
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

export default FailurePopUp;
